export const incidentHasArrestee = (offenses) => {
  let isArrestees = false;
  offenses?.forEach((offense) => {
    let arresteeIds = offense?.offenseDetails?.values?.arresteeIds?.length;
    if (arresteeIds) {
      isArrestees = true;
      return;
    }
  });
  return isArrestees;
};

export const incidentHasKnownOffender = (subjects, parties, offenses) => {
  let hasKnownOffender = false;

  for (const subject of subjects ?? []) {
    let offense = offenses.find(
      (o) => o?.offenseDetails?.ptsOffenseId === subject?.incSubjectDetails?.ptsOffenseId
    )?.offenseDetails?.values;

    // Check only if the subject is part of a valid Group A offense
    if (offense?.excludeOffense === true || offense?.statuteDetails?.FBIGroupCode !== 'A') continue;

    // Check Age, Sex, Race for the valid subjects
    let partyId = subject?.incSubjectDetails?.ptsIncPersonId;
    let party = parties.find((p) => p?.ptsIncPersonId === partyId)?.personDetail?.values;

    if ((party?.age !== 0 && party?.age !== null) && party?.race !== 'U' && party?.sex !== 'U') {
      hasKnownOffender = true;
      break;
    }
  }

  return hasKnownOffender;
};
